import axios from 'axios';
import {
  getCvAccessToken,
  setupAxios,
  RegisterAuth,
  UserRefreshToken,
  getUserState
} from '@carvana/core-auth';
import { getGraphQLAuthHandler } from '@carvana/stc-utilities';

import { BASE_URL } from './helpers';

RegisterAuth({
  name: 'stc-appraisal',
  environment: process.env.NODE_ENV || 'development'
});

const axiosInstance = axios.create({ baseURL: BASE_URL });

const authenticatedAxios = setupAxios(axiosInstance, {
  addBearerTokenToAllRequests: true
});

authenticatedAxios.interceptors.request.use(async config => {
  if (config.data && typeof config.data === 'object' && config.data.query) {
    try {
      const { isLoggedIn } = getUserState();
      if (isLoggedIn) {
        const currentAccessToken = getCvAccessToken();
        if (!currentAccessToken) {
          const refreshSuccess = await UserRefreshToken();
          if (refreshSuccess) {
            const freshToken = getCvAccessToken();
            if (freshToken) {
              config.headers.Authorization = `Bearer ${freshToken}`;
            }
          }
        }
      }
    } catch {
      // If verification fails, continue with request - let existing handlers deal with it
    }
  }
  return config;
});

const graphQLAuthHandler = getGraphQLAuthHandler(axiosInstance, getCvAccessToken);
authenticatedAxios.interceptors.response.use(graphQLAuthHandler);

export { authenticatedAxios, axiosInstance };
